import React from 'react';
import { Typography, Box } from '@mui/material';

const ContentError = function ContentError({
  text = null,
  icon = null,
  message = null,
  sizes = '1.5vw',
}) {
  return (
    <Box
      sx={{
        padding: '1vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      {icon}
      <Typography variant="h5" sx={{ color: '#acacac', fontSize: sizes.title }}>
        {text}
      </Typography>
      <Typography
        variant="h6"
        sx={{ color: '#acacac', fontSize: sizes.message, textAlign: 'center' }}
      >
        {message}
      </Typography>
    </Box>
  );
};

export default ContentError;
